'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource(null, null, {
            numeric: {url: 'api/operators/numeric', method: 'GET'},
            default: {url: 'api/operators/default', method: 'GET'},
        });
    }];